import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CommonSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNode: '',
      dropdownVisible: false,
      nodes: [],
    };
  }

  toggleDropdown = () => {
    this.setState(prevState => ({
      dropdownVisible: !prevState.dropdownVisible,
    }), () => {
      if (this.state.dropdownVisible) {
        document.addEventListener('click', this.hideDropdown, false);
      } else {
        document.removeEventListener('click', this.hideDropdown, false);
      }
    });
  }

  hideDropdown = e => {
    if (this.studySelElement && this.studySelElement.contains(e.target)) {
      return;
    }
    this.toggleDropdown();
    return;
  }

  updatePreferences = node => {
    this.toggleDropdown();
    this.props.onSelection(node);
  }

  render() {
    const { field, width = '300px', defaultLabel, defaultValue, buttonStyle,
      downArrow, appendValue } = this.props;
      let selectedLabel = '';
    if (defaultLabel) {
      selectedLabel = appendValue ? `${defaultLabel} ( ${defaultValue} )` : defaultLabel;
    } else {
      appendValue ? `${field[0].label} ( ${field[0].value} )` : field[0].label;
    }
    return (
      <div className="custom-select-dropdown" ref={node => (this.studySelElement = node)}>
        <span className="custom-select-dropdown-label">{this.props.label}</span>
        <div className="custom-select-dropdown-div" style={{ width }}>
          <button
            className={`custom-select-dropdown-btn ${this.state.dropdownVisible ? 'active' : ''}`}
            onClick={this.toggleDropdown} style={buttonStyle}
          >
            {defaultLabel || field[0].label}
            {downArrow ? <span className="custom-select-down-arrow-icon" /> :
              <span className="custom-select-dropdown-arrow-icon" />}
          </button>
          {this.state.dropdownVisible &&
            <div className="custom-select-dropdown-list">
              {field !== undefined &&
                <div className="custom-select-dropdown-result-listing">
                  <ul>
                    {(field.length > 0 ?
                    this.props.field : this.state.nodes).map(node => (
                      <li key={node.label} className={'custom-select-dropdown-result-list'}>
                        <button
                          title={appendValue ? `${node.label} ( ${node.value} )` : node.label}
                          onClick={() => this.updatePreferences(node.value)}
                          className="custom-select-dropdown-result-list-title"
                        >
                          {appendValue ? `${node.label} ( ${node.value} )` : node.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      </div>
    );
  }
}

CommonSelect.propTypes = {
  field: PropTypes.instanceOf(Array).isRequired,
  style: PropTypes.shape({
    width: PropTypes.string,
  }),
  label: PropTypes.string,
  onSelection: PropTypes.func,
  width: PropTypes.string,
  defaultLabel: PropTypes.string,
  buttonStyle: PropTypes.shape({}),
  downArrow: PropTypes.bool,
};

export default CommonSelect;
